// extracted by mini-css-extract-plugin
module.exports =  {"root":"IzZkrs0C6nrdVqIyXlJO","url":"UuFpAl0dRt34_uWavSh7"};